import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import { ChangePassword } from '@artegeie/mrc/profile';
import { onLogout } from '@artegeie/mona-sdk/auth'

import useMrcAuth from 'Hooks/useMrcAuth';

import 'scss/components/content/account.scss';

export default function AccountChangePassword() {

	const navigate = useNavigate();

	const authMrc = useMrcAuth();

	useEffect(() => {
		onLogout((detail) => {
			if (detail.kind === 'SSO_MONASDK_LOGOUT') {
				navigate( '/account-login', { trigger: true } );
			}
		})
	}, [] );

	return (
		<div id='account-page' className="account-change-password">
			{ authMrc.loginState && <ChangePassword /> }
		</div>
	);
};
